module.exports = __webpack_public_path__ + "img/erro-404.79ca6ca7.png";